import Rest from 'services/data/rest';
import moment from 'moment';
import axios from 'axios';
import Promise from 'bluebird';
import _ from 'lodash';

// Utils
import { formatFileUploadFormData } from 'utils/form-utils';
import { getDateRangeFilter } from 'utils/filter-utils';

class Agreement extends Rest {
  static path = 'agreement';
  static activeQuery = {
    where: {
      endDate: { or: { '>=': moment().startOf('day').toDate(), is: null } },
      startDate: { '<': moment().toDate() }
    }
  };
  static defaultQuery = {
    sort: 'title',
    load: ['company', 'signedAgreements']
  };

  static mapFilters(filters) {
    const { startDate, endDate, agreementType, team, ...where } = filters;

    where.startDate = getDateRangeFilter(startDate);
    where.endDate = getDateRangeFilter(endDate);
    where['company.team'] = team;

    if (!endDate.max) where.endDate = { or: _.assign(where.endDate, { is: null }) };

    _.forEach(agreementType, type => {
      if (type === 'Monthly') _.set(where, 'or.monthly', true);
      if (type === 'Hourly') _.set(where, 'or.timeDefaultBillable', true);
      if (type === 'Fixed') {
        _.set(where, 'or.and.monthly', false);
        _.set(where, 'or.and.timeDefaultBillable', false);
      }
    });

    return where;
  }

  static getBillingTypes(agreement, asArray = false) {
    const types = [];

    if (agreement.monthly) types.push('Monthly');
    if (agreement.timeDefaultBillable) types.push('Hourly');
    if (!agreement.monthly && !agreement.timeDefaultBillable) types.push('Fixed');

    return asArray ? types : _.join(types, ', ');
  }

  static isInactive(agreement) {
    return moment(agreement.endDate).isBefore(moment().startOf('day'));
  }

  static create(agreement) {
    return Promise.resolve(axios.post('/api/agreement', formatFileUploadFormData(agreement, ['signedAgreements'])))
      .tap(this.logRequest)
      .get('data');
  }

  static update(agreement) {
    return Promise.resolve(axios.put(`/api/agreement/${agreement.id}`, formatFileUploadFormData(agreement, ['signedAgreements'])))
      .tap(this.logRequest)
      .get('data');
  }
}

// Exports
export default Agreement;
